import { ToolType } from "@repo/app-types/entities/tool";

/** What the admin calls each type of voice agent tool. */
export const toolTypeTitles: { readonly [T in ToolType]: string } = {
  [ToolType.CALL_TRANSFER]: "Call transfer",
  [ToolType.CALL_END]: "End call",
  [ToolType.CUSTOM]: "Custom",
  [ToolType.CODE]: "Code",
  [ToolType.WEB_DOCUMENT_RESEARCH]: "Web document research",
};
